import * as React from "react";
import { forwardRef } from "react";
const SvgCircle = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	height: "1em",
	viewBox: "0 0 595.021 595.021",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M507.529,87.493c-27.264-27.264-59.022-48.672-94.396-63.635C376.489,8.358,337.588,0.5,297.511,0.5     c-40.078,0-78.979,7.858-115.624,23.358c-35.373,14.961-67.132,36.371-94.395,63.635c-27.264,27.263-48.673,59.022-63.635,94.395     C8.358,218.532,0.5,257.434,0.5,297.511c0,40.077,7.858,78.979,23.358,115.623c14.961,35.373,36.371,67.132,63.635,94.396     c27.263,27.263,59.022,48.672,94.395,63.634c36.645,15.5,75.546,23.358,115.624,23.358c40.077,0,78.979-7.858,115.623-23.358     c35.373-14.961,67.133-36.371,94.396-63.634c27.263-27.264,48.673-59.022,63.634-94.396     c15.499-36.645,23.358-75.546,23.358-115.623c0-40.077-7.858-78.979-23.358-115.624     C556.202,146.515,534.792,114.756,507.529,87.493z M297.511,551.682c-140.375,0-254.171-113.797-254.171-254.171     c0-140.375,113.796-254.171,254.171-254.171c140.374,0,254.171,113.796,254.171,254.171     C551.682,437.885,437.885,551.682,297.511,551.682z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgCircle);
export default ForwardRef;
